import Vue from 'vue';
import Vuex from 'vuex';
import okiStore from '../../../applications/oki/oki-vuex';
import okiPersonalStore from '../../../applications/oki/oki-personal/oki-personal-vuex';
import okiFinancialStore from '../../../applications/oki/oki-financial/oki-financial-vuex';
import okiCardUploadStore from '../../../applications/oki/oki-card-upload/oki-card-upload-vuex';

const storeConfig = Object.assign({ strict: process.env.NODE_ENV !== 'production' }, okiStore, {
	modules: { personal: okiPersonalStore, financial: okiFinancialStore, carddata: okiCardUploadStore }
});

Vue.use(Vuex);
export default new Vuex.Store(storeConfig);
